import React from 'react';

import KPTable from '../../../../components/KPTComponents/KPTable';

import { ActionColumn } from '../../../../containers/DangKyHoSo/utils';
import { CRUD_MODELS, SOLUTION_MODEL } from '../../../../constants';
import { Chip } from '@mui/material';

function SangCheTable({ rows, setDialog, ...props }) {
  const columns = [
    { ...SOLUTION_MODEL.title, xs: '60%' },
    {
      ...SOLUTION_MODEL.role,
      xs: '20%',
      filters: SOLUTION_MODEL.role.options,
      render: (value) => SOLUTION_MODEL.role.options.find((e) => e.value === value)?.title,
      onFilter: (value, row) => row.role === value,
    },
  ];

  if (props.setDuyetThanhTich) {
    columns.push({
      key: "numberAuthor",
      label: "Số tác giả",
      align: "center",
      width: "5%",
      render: (_, row) => row.numberAuthor,
    });
    columns.push({
      key: "point",
      label: "Điểm",
      align: "center",
      width: "5%",
      render: (_, row) => row.scoringTable?.point,
    });
    columns.push({
      key: "point",
      label: "Điểm tối đa",
      align: "center",
      width: "5%",
      render: (_, row) => row.scoringTable?.maxPoint,
    });
    columns.push({
      key: "note",
      label: "Ghi chú",
      align: "center",
      width: "10%",
      render: (_, row) => row.scoringTable?.note,
    });
    columns.push({
      key: "accepted",
      label: "Trạng thái",
      align: "center",
      width: "15%",
      render: (_, row) => (
        <Chip
          size="small"
          color={
            row.scoringTable?.accepted || row?.notEligible
              ? "primary"
              : "default"
          }
          label={
            row.scoringTable?.accepted || row?.notEligible
              ? "Đã chấm"
              : "Chưa chấm"
          }
          variant={
            row.scoringTable?.accepted || row?.notEligible
              ? "filled"
              : "outlined"
          }
        />
      ),
    });
  }

  columns.push({
    key: "link",
    label: "Tác vụ",
    width: "20%",
    render: (_, row) => (
      <ActionColumn
          row={row}
          type={CRUD_MODELS.SOLUTION}
          setDialog={setDialog}
          setPreview={props.setPreview}
          setDuyetThanhTich={props.setDuyetThanhTich}
          setDeleteCrud={props.setDeleteCrud}
          setChoDiem={props.setChoDiem}
        />
    ),
  });

  return (
    <KPTable
      columns={columns}
      nonBorder={!!props.nonBorder}
      rows={rows}
      // loading={loading}
    />
  );
}

export default SangCheTable;
